import { jsx as r } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useState as h, useCallback as y, useMemo as O, useEffect as R } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import E from "../../../../../core/Context/useCoreContext.js";
import F from "../../../../../hooks/useTimezoneAwareDateFormatting.js";
import { GRANT_ACTION_CLASS_NAMES as l } from "./constants.js";
/* empty css                 */
import { Alert as p } from "../../../../internal/Alert/Alert.js";
import { AlertTypeOption as f } from "../../../../internal/Alert/types.js";
import { useFetch as S } from "../../../../../hooks/useFetch.js";
import "../../../../../external/preact/compat/dist/compat.module.js";
import { getTopWindowHref as _, setTopWindowHref as b } from "./utils.js";
import d from "../../../../internal/Button/Button.js";
import { DATE_FORMAT_CAPITAL_OVERVIEW as I } from "../../../../../constants/dateFormats.js";
import { useConfigContext as N } from "../../../../../core/ConfigContext/context.js";
import { EMPTY_OBJECT as W } from "../../../../../utils/value/constants.js";
const D = ({ action: n, className: s, offerExpiresAt: m }) => {
  const { i18n: e, updateCore: u } = E(), { dateFormat: T } = F(), { signToSActionDetails: t } = N().endpoints, [i, C] = h(!1), g = y(async () => {
    if (n.type === "signToS")
      return t == null ? void 0 : t(W, {
        query: {
          redirectUrl: _(),
          locale: e.locale
        }
      });
  }, [n, e.locale, t]), { data: o, isFetching: a, error: A } = S({
    fetchOptions: O(() => ({ enabled: !!t && i }), [t, i]),
    queryFn: g
  });
  return R(() => {
    const c = o == null ? void 0 : o.url;
    c && b(c);
  }, [o, i]), A ? /* @__PURE__ */ r(
    p,
    {
      className: s,
      type: f.CRITICAL,
      title: e.get("somethingWentWrongTryRefreshingOrComeBackLater"),
      description: /* @__PURE__ */ r(d, { className: l.button, onClick: u, children: e.get("refresh") })
    }
  ) : /* @__PURE__ */ r(
    p,
    {
      className: s,
      type: f.WARNING,
      title: `${e.get("capital.signTermsAndConditionsToReceiveFunds")}${m ? ` ${e.get("capital.thisOfferExpiresOn", {
        values: {
          date: T(m, I)
        }
      })}` : ""}`,
      description: /* @__PURE__ */ r(
        d,
        {
          className: l.button,
          onClick: () => C(!0),
          disabled: a,
          state: a ? "loading" : void 0,
          children: e.get("capital.goToTermsAndConditions")
        }
      )
    }
  );
};
export {
  D as GrantAction
};
